import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SeoData } from "../../types/serviceDetail";
import SeoMeta from "../metaHead/SeoMeta";

const SeoLoader = () => {
  const [seoData, setSeoData] = useState<SeoData | null>(null);
  const [loading, setLoading] = useState<boolean>(true); // Track loading state
  const [error, setError] = useState<string | null>(null); // Track error state
  const location = useLocation();
  const baseUrl = import.meta.env.VITE_API_URL;

  const finalSlug = location.pathname.startsWith("/")
    ? location.pathname.slice(1)
    : location.pathname;

  useEffect(() => {
    setLoading(true); // Set loading to true when the request starts
    setError(null); // Clear previous error

    fetch(`${baseUrl}/api/page-seo/seo-details?slug=${finalSlug}`)
      .then((response) => {
        if (!response.ok) {
            return '';
        }
        return response.json();
      })
      .then((data) => {
        if (!data.metaTags) {
            return '';
        }

        const formattedData: SeoData = {
          ...data,
          thirdPartyScripts: data.thirdPartyScripts.map((script: any) => ({
            ...script,
            script_position: script.script_position === "head" ? "head" : "body",
          })),
        };
        setSeoData(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching SEO data:", error);
        setError(error.message); // Set error message on failure
      })
      .finally(() => {
        setLoading(false); // Set loading to false once data fetching is complete
      });
  }, [finalSlug]);

  if (loading) {
    return ''; // Show loading state
  }

  if (error) {
    return ''; // Show error message
  }

  if (!seoData?.metaTags) {
    return ''; // Fallback if no metaTags are present
  }

  return <SeoMeta seoData={seoData} />;
};

export default SeoLoader;
